import { io } from 'socket.io-client';
import wsProtocol from '@/js/wsProtocol';

export const initAndGetUserSocket = (uid) => {
    return io(`${wsProtocol}://${process.env.VUE_APP_WS_HOST}`, {
        transports: ['websocket'],
        query: { uid },
    });
};
